import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { MicroserviceTypes } from 'typings';
import { usePurchaseOrderByIdQuery } from 'api';

export const PurchaseOrderAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  const { data: purchaseOrderDetails = {} } = usePurchaseOrderByIdQuery({ id }, { skip: !id });
  const isFinalStatus = purchaseOrderDetails?.purchaseOrder?.isFinalStatus;

  return (
    <Attachments
      entityId={id}
      entityName={'PURCHASE_ORDER'}
      service={'wrd' as MicroserviceTypes}
      hasAccessToWrite={hasAccess(PERMISSIONS.purchaseOrders.attachment.write) && !isFinalStatus}
      hasAccessToDelete={hasAccess(PERMISSIONS.purchaseOrders.attachment.delete) && !isFinalStatus}
    />
  );
});
